import React from 'react';
import './subscriptionAlreadyActivated.scss';

const subscriptionAlreadyActivated = () => {
    return (
        <div className='already-activated'>Please contact your administrator, as somebody from your organization already activated Syskit Point.</div>
    );
};

export default subscriptionAlreadyActivated;